import angular from 'angular';
import { MeurhSolicitacoespromocoesService } from '../promocoes.service';
import { ListagemService } from '../../../../shared/services/listagem.service';
import { IPromocao } from '../models/promocao.model';
import { Empresa, Estabelecimento } from '../../../../core/usuario/models/usuario-model';

type IMeurhPromocoesListFilter = {
    empresa?: string;
    estabelecimento?: string;
    situacao?: string;
    status?: string;
    lotacao?: {
        lotacao: string;
    } | null;
};

export class MeurhPromocoesListController implements angular.IController {
    static $inject = [
        '$rootScope',
        '$scope',
        '$stateParams',
        '$location',
        'MeurhSolicitacoespromocoesService',
        'ListagemService'
    ];

    public busy: boolean = false;
    public entities: Array<IPromocao>;
    public filters: IMeurhPromocoesListFilter = {
        status: '00'
    };
    public dataInicial: string | null = null;
    public dataFinal: string | null = null;
    public empresas: Array<Empresa>;
    public estabelecimentos: Array<Estabelecimento>;
    public listagemPermissao: Array<string> = ['visualizar_promocoes'];
    public permissaoGrupoEmpresarial = false;

    constructor(
        public $rootScope: angular.IRootScopeService & {
            temPermissaoGrupoEmpresarial: (permissoes: string[], grupo: string) => boolean,
            modoGestorPermissao: (arg: string) => boolean
            session: any,
            nsjGlobals: any
        },
        public $scope: angular.IScope,
        public $stateParams: angular.ui.IStateParamsService,
        public $location: angular.ILocationService,
        public entityService: MeurhSolicitacoespromocoesService,
        public ListagemService: ListagemService
    ) {
        this.busy = true;
        entityService.filter = $stateParams['q'] ? $stateParams['q'] : '';
        entityService.filters = {};
        entityService.constructors = {};

        this.permissaoGrupoEmpresarial = $rootScope.temPermissaoGrupoEmpresarial(
            this.listagemPermissao,
            $rootScope.nsjGlobals.a.grupoempresarial
        );

        this.filters = {
            ...this.filters,
            empresa: $rootScope.session.entities.empresa.empresa,
            estabelecimento: $rootScope.session.entities.estabelecimento.estabelecimento,
        };

        this.montaListagemVisibilidade();
        this.filterReload();

        $scope.$on('meurh_solicitacoespromocoes_list_finished', () => {
            this.busy = false;
        });
        $scope.$on('meurh_solicitacoespromocoes_loaded', () => {
            this.busy = false;
        });
    }

    montaListagemVisibilidade() {
        this.empresas = this.ListagemService.montaEmpresas(this.$rootScope.nsjGlobals.a.grupoempresarial, this.listagemPermissao);
        this.estabelecimentos = this.ListagemService.montaEstabelecimentos(this.filters.empresa!, this.empresas, this.listagemPermissao);
    }

    mudaEstabelecimentos() {
        this.estabelecimentos = this.filters.empresa ? this.ListagemService.montaEstabelecimentos(this.filters.empresa, this.empresas, this.listagemPermissao) : [];
        this.filters.estabelecimento = '';
        this.filtraEmpresaEstabelecimento();
    }

    filtraEmpresaEstabelecimento() {
        delete this.filters.lotacao;
        this.$rootScope.$broadcast('lotacao_refresh', this.constructorEmpresaEstabelecimento());
        this.filterReload();
    }

    constructorEmpresaEstabelecimento() {
        return {
            'empresa': this.filters.empresa,
            'estabelecimento': this.filters.estabelecimento
        };
    }

    isBusy(): boolean {
        return this.entityService.loadParams.busy;
    }

    search() {
        if (this.entityService.filter !== '') {
            this.$location.path(this.$location.path()).search(angular.extend({}, this.entityService.filters, { 'q': this.entityService.filter }));
        } else {
            this.$location.path(this.$location.path()).search(angular.extend({}, this.entityService.filters));
        }

        const filter = {
            search: this.entityService.filter,
            filters: angular.copy(this.entityService.filters)
        };
        return this.entityService.search(filter);
    }

    filterReload(): void {
        this.busy = true;

        const constructors: any = { ...this.filters };

        if (!this.valorExiste(constructors.lotacao)) {
            delete constructors.lotacao;
        } else {
            constructors.lotacao = constructors.lotacao.lotacao;
        }

        if (!this.valorExiste(constructors.situacao)) {
            delete constructors.situacao;
        }

        if (!this.valorExiste(constructors.status)) {
            delete constructors.status;
        }

        const data: { condition: string, value: string }[] = [];

        if (
            this.dataInicial === undefined ||
            (this.dataInicial !== null && this.dataInicial.length === 0)
        ) {
            this.dataInicial = null;
            constructors.datainicial = null;
        }

        if (this.dataInicial !== null) {
            data.push({
                condition: 'gte',
                value: this.dataInicial + ' 00:00:00'
            });
            delete constructors.datainicial;
        }

        if (
            this.dataFinal === undefined ||
            (this.dataFinal !== null && this.dataFinal.length === 0)
        ) {
            this.dataFinal = null;
            constructors.datafinal = null;
        }

        if (this.dataFinal !== null) {
            data.push({
                condition: 'lte',
                value: this.dataFinal + ' 23:59:00'
            });
            delete constructors.datafinal;
        }

        constructors.data = data;
        constructors['forcagestor'] = this.$rootScope.modoGestorPermissao('visualizar_promocoes');
        this.entityService.constructors = constructors;
        this.entities = this.entityService.reload();
    }

    valorExiste(valor: any): boolean {
        return valor !== '' && valor !== undefined && valor !== null ? true : false;
    }
}
